import dayjs from 'dayjs';

import { ExtPersonDocument, PersonDocument } from 'services/SwaggerApi';

export const isDocumentExpired = (document: PersonDocument | ExtPersonDocument) =>
    document.expires_on && dayjs(document.expires_on).isBefore(dayjs());
